
import { NgxPaginationModule } from 'ngx-pagination';
import { MatButtonModule, MatTabsModule, MatSelectModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatNativeDateModule, MatCheckboxModule, MatRadioModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { appRoutes } from './../routes';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router';


import { AppComponent } from './sainik.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AuthGuard } from './auth/auth.guard';
import { UserService } from './shared/user.service';
import { ErrorHandler } from './shared/ErrorHandler';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { ClaimsComponent } from './ultilities/claims/claims/claims.component';
import { RolesComponent } from './ultilities/roles/roles.component';
import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
import { SignupComponent } from './registration/signup/signup.component';
import { ClaimFormComponent } from './ultilities/claims/claims/claim-form/claim-form.component';
import { ClaimGridComponent } from './ultilities/claims/claims/claim-grid/claim-grid.component';
import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
import { RegistrationComponent } from './registration/registration.component';
import { HomepageComponent } from './homepage/homepage.component';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { LoginComponent } from './registration/login/login.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from './common/footer/footer.component';
import { SainikSidenavComponent } from './sainik-sidenav/sainik-sidenav.component';
import { AwardsComponent } from './sainik-registration/awards/awards.component';
import { BattlecasualtyComponent } from './sainik-registration/battlecasualty/battlecasualty.component';
import { DependentsComponent } from './sainik-registration/dependents/dependents.component';
import { BankinfoComponent } from './sainik-registration/bankinfo/bankinfo.component';
import { UploadsComponent } from './sainik-registration/uploads/uploads.component';
import { BreadnavComponentComponent } from './sainik-registration/breadnav-component/breadnav-component.component';
import { GrievenceLodgingComponent } from './grievence-lodging/grievence-lodging/grievence-lodging.component';
import { SainikRegistrationComponent } from './sainik-registration/sainik-registration.component';
import { HeaderComponent } from './common/header/header.component';
import { BasicRegistrationComponent } from './sainik-registration/basic-registration/basic-registration.component';
import { PensionComponent } from './sainik-registration/pension/pension.component';
import { GrievenceAddressingComponent } from './Grievances-Addressing/grievence-addressing/grievence-addressing.component';
import { FundManagementComponent } from './fund-management/fund-management.component';
//import { CorrespondenceTrackingComponent } from './correspondence-tracking/correspondence-tracking.component';
import { Form1Component } from './forms/form1/form1.component';
import { FormViewComponent } from './forms/form-view/form-view.component';
import { BasicRegFromViewComponent } from './sainik-registration/basic-reg-from-view/basic-reg-from-view.component';
import {TitleComponent} from './text-title-component';
import { RegistrationService } from './registration.service';
import { OtherModules } from './OtherNodules.component';
import { OfficeGridComponent } from './ultilities/office/office-grid/office-grid.component';
import { OfficeFormComponent } from './ultilities/office/office-form/office-form.component';
import { BigTitleComponent } from './ultilities/utility-txt';
import { DashboardComponent } from './schemes/dashboard/dashboard.component';
import { HandleError } from './shared/HandleError';
import { SainikAccountComponent } from './registration/sainik-account/sainik-account.component';
import { AccountHeadComponent } from './Finance/account-head/account-head.component';
import { SubHeadComponent } from './Finance/sub-head/sub-head.component';
import { FinanceComponent } from './finance/finance.component';
import { FinanceMenuComponent } from './finance/finance-menu/finance-menu.component';
import { AccheadGridComponent } from './finance/acchead-grid/acchead-grid.component';
import { SubheadGridComponent } from './finance/subhead-grid/subhead-grid.component';
import { TransactionGridComponent } from './finance/transaction-grid/transaction-grid.component';
import { TransactionComponent } from './finance/transaction/transaction.component';
import { CreatePasswordComponent } from './registration/create-password/create-password.component';
import { CreatePasswordphComponent } from './registration/create-passwordph/create-passwordph.component';
import { SchemesComponent } from './schemes/schemes.component';
import { SchemesMenuComponent } from './schemes/schemes-menu/schemes-menu.component';
import { ApplicationsGridComponent } from './schemes/applications-grid/applications-grid.component';
import { ApplicationHistoryComponent } from './schemes/application-history/application-history.component';
import { ApprovalsGridComponent } from './schemes/approvals-grid/approvals-grid.component';
import { CorrespondanceTrackingComponent } from './correspondence-tracking/correspondance-tracking.component';
import { CtGridComponent } from './correspondence-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './correspondence-tracking/ct-form/ct-form.component';
import { CtMenuComponent } from './correspondence-tracking/ct-menu/ct-menu.component';
import { GrievenceGridComponent } from './grievence-lodging/grievence-grid/grievence-grid.component';
import { GrievacesAddressingGridComponent } from './Grievances-Addressing/grievaces-addressing-grid/grievaces-addressing-grid.component';

import { BudgetGridComponent } from './finance/budget/budget-grid/budget-grid.component';
import { BudgetFormComponent } from './finance/budget/budget-form/budget-form.component';
import { ReceiptFormComponent } from './finance/receipt/receipt-form/receipt-form.component';
import { ReceiptGridComponent } from './finance/receipt/receipt-grid/receipt-grid.component';

import { ApprovanceGridComponent } from './finance/approvance/approvance-grid/approvance-grid.component';
import { ApprovanceFormComponent } from './finance/approvance/approvance-form/approvance-form.component';

import { RankLevelFormComponent } from './masters/rank-levels/rank-level-form/rank-level-form.component';
import { RankLevelGridComponent } from './Masters/Rank-Levels/rank-level-grid/rank-level-grid.component';
import { StationGridComponent } from './Masters/stations/station-grid/station-grid.component';
import { StationFormComponent } from './Masters/Stations/station-form/station-form.component';
import { MilitaryOperationFormComponent } from './Masters/military-operations/military-operation-form/military-operation-form.component';
import { MilitaryOperationGridComponent } from './Masters/military-operations/military-operation-grid/military-operation-grid.component';
import { PensionIssuingAuthorityGridComponent } from './Masters/pension-issuing-authority/pension-issuing-authority-grid/pension-issuing-authority-grid.component';
import { PensionIssuingAuthorityFormComponent } from './Masters/Pension-Issuing-Authority/pension-issuing-authority-form/pension-issuing-authority-form.component';
import { MastersComponent } from './masters/masters.component';
import { OfficeComponent } from './ultilities/office/office.component';
import { UserComponent } from './ultilities/user/user.component';
import { ReportsComponent } from './sainik-registration/Reports/reports.component';
import {SainikReportsComponent} from './sainik-reports/sainik-reports.component';
import {SainikReportsPagesComponent} from './sainik-reports/sainik-reports-pages/sainik-reports-pages.component';
import { ViewSainikComponent } from './sainik-registration/view-sainik/view-sainik.component'
// Rohit New 
import { DependentsDocumentUploadsComponent } from './sainik-registration/dependents-document-uploads/dependents-document-uploads.component'



@NgModule({
  declarations: [
    AppComponent,
    UltilitiesComponent,
    UltilitiesMenuComponent,
    ClaimsComponent,
    RolesComponent,
    RolesGridComponent,
    RolesFormComponent,
    SignupComponent,
    UserGridComponent,
    UserFormComponent,
    ClaimGridComponent,
    ClaimFormComponent,
    RegistrationComponent,
    HomepageComponent,
    ChangePasswordComponent,
    LoginComponent,
    ForgotPasswordComponent,    

    BigTitleComponent,
    TitleComponent,  
    FooterComponent,
    SainikSidenavComponent,
    AwardsComponent,
    BattlecasualtyComponent,
    DependentsComponent,
    BankinfoComponent,
    UploadsComponent,
    BreadnavComponentComponent,
    GrievenceLodgingComponent,
    SainikRegistrationComponent,
    HeaderComponent,
    BasicRegistrationComponent,
    PensionComponent,
    GrievenceAddressingComponent,
    FundManagementComponent,
    //CorrespondenceTrackingComponent,
    Form1Component,
    FormViewComponent,
    BasicRegFromViewComponent,
    OtherModules,
    OfficeGridComponent,
    OfficeFormComponent,
    DashboardComponent,
    SainikAccountComponent,
    AccountHeadComponent,
    SubHeadComponent,    
    FinanceComponent, 
    FinanceMenuComponent, 
    AccheadGridComponent, 
    SubheadGridComponent, 
    TransactionGridComponent, TransactionComponent, CreatePasswordComponent, CreatePasswordphComponent ,  SchemesComponent, SchemesMenuComponent, ApplicationsGridComponent, ApplicationHistoryComponent, ApprovalsGridComponent,
    CorrespondanceTrackingComponent,CtGridComponent,CtFormComponent,CtMenuComponent, GrievenceGridComponent, GrievacesAddressingGridComponent, 
    BudgetGridComponent, BudgetFormComponent, 
    ReceiptFormComponent, ReceiptGridComponent, 
    ApprovanceGridComponent, ApprovanceFormComponent,RankLevelFormComponent, RankLevelGridComponent, StationGridComponent, StationFormComponent, MilitaryOperationFormComponent, MilitaryOperationGridComponent, PensionIssuingAuthorityGridComponent, PensionIssuingAuthorityFormComponent, MastersComponent,
  //gg
  OfficeComponent,
  UserComponent,
  ReportsComponent,
  SainikReportsComponent,
  SainikReportsPagesComponent,
  ViewSainikComponent,
  //Rohit New 
  DependentsDocumentUploadsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule, MatCheckboxModule,MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule, 
    MatNativeDateModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    RouterModule.forRoot(appRoutes)

  ],
  providers: [
    UserService,RegistrationService,HandleError,ErrorHandler,AuthGuard,{provide: LocationStrategy, useClass: HashLocationStrategy},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/sainik.module.ts